<div class="context-menu-box" click-stop-propagation>
  <div class="context-menu-box__image noSelect">
    <app-user-avatar
      [avatarUrl]="baseAvatarUrl + 'avatars/' + currentUser.avatar"
      [userFullName]="currentUser.firstName + ' ' + currentUser.lastName"
      [width]="100"
      [height]="100"
      [fontSizeInPx]="22"
    >
    </app-user-avatar>
  </div>
  <div
    class="context-menu-box__user-name"
    nbTooltipStatus="control"
    nbTooltip="{{ currentUser.firstName }} {{ currentUser.lastName }}"
    nbTooltipPlacement="top"
  >
    {{ currentUser.firstName }} {{ currentUser.lastName }}
  </div>
  <div class="context-menu-box__roles">
    [
    <div
      class="role"
      *ngFor="let role of currentUser.roles; trackBy: trackByFn"
    >
      {{ role }}
    </div>
    ]
  </div>
  <div class="context-menu-box__email">
    <nb-icon icon="email-outline"></nb-icon> {{ currentUser.email }}
  </div>
  <div class="context-menu-box__organization-name">
    <nb-icon icon="briefcase-outline"></nb-icon>
    {{ currentUser.organizationName }}
  </div>
  <div class="context-menu-box__two-fa">
    <nb-icon
      [icon]="
        currentUser.twoFactorEnabled ? 'shield-outline' : 'shield-off-outline'
      "
      [ngClass]="{ 'icon-success': currentUser.twoFactorEnabled }"
    ></nb-icon>
    {{ "common.two-factor-authentication" | translate }}
    <button
      *ngIf="!currentUser.twoFactorEnabled"
      nbButton
      size="tiny"
      status="success"
      appearance="outline"
      (click)="onTwoFactorSetup()"
      tabindex="-1"
    >
      {{ "common.setup" | translate }}
    </button>
  </div>

  <div class="context-menu-box__buttons">
    <button
      nbButton
      size="medium"
      status="control"
      appearance="outline"
      (click)="logout()"
      tabindex="-1"
    >
      {{ "user.log-out" | translate }}
    </button>
  </div>
  <div class="context-menu-box__footer">
    <button (click)="redirectToPrivacyPolicy()">
      {{ "landing-page.privacy-policy" | translate }}
    </button>
    |
    <button (click)="openTerms()">
      {{ "landing-page.terms-and-conditions" | translate }}
    </button>
  </div>
</div>
